import { Routes, Route, Navigate } from 'react-router-dom'

import ProjectListView from 'Presentation/Views/Project/List/View'
import ProjectGanttChartView from 'Presentation/Views/Project/GanttChart/View'
import ProjectDetailView from 'Presentation/Views/Project/Detail/View'
import ProjectPileScanView from 'Presentation/Views/Project/PileScan/View'
import ProjectPileExecutionView from 'Presentation/Views/Project/PileExecution/View'
import ProjectPileExecutedListView from 'Presentation/Views/Project/PileExecutedList/View'
import { PileExecutedStatusChangerContextProvider } from 'Presentation/Views/Project/PileExecutedStatusChanger/Context'
import { ProjectListViewContextProvider } from 'Presentation/Views/Project/List/Context'
import { PileExecutionAttachmentContextProvider } from 'Presentation/Views/Project/PileExecutionAttachment/Context'
import ProtectedRoutePermission from '../ProtectedRoutePermission'
import RolePermissionConfigs from 'Configuration/RolePermission'

const ProjectRoutes = () => (
  <Routes>
    <Route element={<ProtectedRoutePermission whitelist={RolePermissionConfigs.project} />}>
      <Route path=':id/gantt-chart' element={<ProjectGanttChartView />} />

      <Route path=':id/pile-scan' element={<ProjectPileScanView />} />
      <Route
        path=':id/pile-execution'
        element={
          <PileExecutionAttachmentContextProvider>
            <ProjectPileExecutionView />
          </PileExecutionAttachmentContextProvider>
        }
      />
      <Route
        path=':id/pile-executed-list'
        element={
          <PileExecutedStatusChangerContextProvider>
            <ProjectPileExecutedListView />
          </PileExecutedStatusChangerContextProvider>
        }
      />
      <Route path=':id/*' element={<ProjectDetailView />} />

      <Route
        index
        element={
          <ProjectListViewContextProvider>
            <ProjectListView />
          </ProjectListViewContextProvider>
        }
      />

      <Route path='*' element={<Navigate to='/home' />} />
    </Route>
  </Routes>
)

export default ProjectRoutes
